/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { toast } from 'react-hot-toast' // Npm: React hot toast.
import { useMutation } from '@apollo/client' // Npm: Apollo client.
import { connect } from 'react-redux' // Npm: React Redux for state management.


/*
 * SIBLINGS
 */
import DeleteCard from 'components/DeleteCard'


/*
 * GRAPHS
 */
import VendorInvoiceDeleteMutation from './__mutation__/index.vendorInvoice.delete.mutation'


/*
 * OBJECTS
 */
const Index = ({ passOn, onClose, onSuccess }) => {
  // Hook assignment.
  const [MutationVendorInvoiceDelete, MutationVendorInvoiceDeleteResponse] =
    useMutation(VendorInvoiceDeleteMutation);

  // Return Component.
  return (
    <DeleteCard
      subHeading={`Delete invoice ${passOn?.invoiceNumber ?? "-"}? This action cannot be undone.`}
      onClose={onClose}
      disabled={MutationVendorInvoiceDeleteResponse.loading}
      onConfirm={() =>
        MutationVendorInvoiceDelete({
          variables: {
            vendorInvoiceId: passOn?.vendorInvoiceId,
          },
        })
          .then((i) => {
            // Style Guide.
            toast(i?.data?.VendorInvoiceDelete?.message);

            // Refetch table data.
            onSuccess?.();

            // Report success.
            return onClose?.();
          })
          .catch(() =>
            // Style Guide.
            toast("Something went wrong please try after some time."),
          )
      }
      isLoading={MutationVendorInvoiceDeleteResponse.loading}
    />
  );
};


/*
 * PROPTYPES
 */
Index.propTypes = {
  passOn: PropTypes.object,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
};


/*
 * REDUX
 */
const _MapStateToProps = __state => ({ 'passOn': __state.PassOn })


/*
 * EXPORT
 */
export default connect(_MapStateToProps)(Index)
